import SecurityDepositCRU from './SecurityDepositCRU';
import CashTxnCRU from './CashTxnCRU';
import NonCashTxnCRU from './NonCashTxnCRU';
import SecurityDepositListing from './SecurityDepositListing';
import SecurityDepositConfig from './SecurityDepositConfig';
import CashTxnList from './CashTxnList';
import NonCashTxnList from './NonCashTxnList';
import SecurityDepositInvoiceListModal from './SecurityDepositInvoiceListModal';
export { SecurityDepositCRU, CashTxnCRU, NonCashTxnCRU, SecurityDepositListing, SecurityDepositConfig, CashTxnList, NonCashTxnList, SecurityDepositInvoiceListModal };

export const sdObj = {
    security_deposit_type: {},
    security_deposit_against_id: {},
    base_amount: null,
    contractual_amount: null,
    due_date: null,
    remarks: null,
    is_refundable: false,
    is_repaying_with_interest: false,
    interest_rate_percentage: null
}

export const cashTxnObj = {
    attachments: [],
    base_amount: null,
    contractual_amount: null,
    description: null,
    reference_number: null,
    transaction_date: null,
    validity_end_date: null,
    validity_start_date: null,
}
export const nonCashTxnObj = {
    advising_bank: null,
    attachments: [],
    base_amount: null,
    beneficiary: null,
    confirming_bank: null,
    confirming_loc_location: null,
    confirming_party: null,
    contractual_amount: null,
    issue_date: null,
    issuing_bank: null,
    issuing_bank_reference: null,
    issuing_party: null,
    on_behalf_of: null,
    original_loc_location: null,
    pledged: null,
    purpose_of_instrument: null,
    reference_number: null,
    status: null,
    type_of_financial_instrument: null,
    validity_end_date: null,
    validity_start_date: null
}